module.exports = __webpack_public_path__ + "static/img/Microsoft.e5acdb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Microsoft.png
// module id = unJn
// module chunks = 16